import { render, staticRenderFns } from "./DeleteModalComponent.vue?vue&type=template&id=58bb3284&"
import script from "./DeleteModalComponent.vue?vue&type=script&lang=ts&"
export * from "./DeleteModalComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58bb3284')) {
      api.createRecord('58bb3284', component.options)
    } else {
      api.reload('58bb3284', component.options)
    }
    module.hot.accept("./DeleteModalComponent.vue?vue&type=template&id=58bb3284&", function () {
      api.rerender('58bb3284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/DeleteModalComponent.vue"
export default component.exports